import React from "react";
import { ToastContainer } from "react-toastify";
import { ConfigProvider, ThemeConfig } from "antd";
import COLORS from "constants/Colors";
import useAuth from "hooks/useAuth";
import styles from "./styles.module.scss";

const config: ThemeConfig = {
  token: {
    colorPrimary: COLORS.Primary700,
  },
  components: {
    Table: {
      headerBg: "#FFF",
      headerColor: "#222425",
      fontSize: 16,
      rowHoverBg: "",
    },
  },
};

export default function MainLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  useAuth();

  return (
    <ConfigProvider theme={config}>
      <div className={styles.mainContainer}>
        {children}

        <ToastContainer
          closeButton={false}
          position="top-center"
          autoClose={3000}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </div>
    </ConfigProvider>
  );
}
